/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
import * as React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// import makoLogoImg from 'assets/client/imgs/mako-logo.svg';
// import galgalazLogoImg from 'assets/client/imgs/Galgalz.svg';

import siteLogoImg from 'assets/client/imgs/site-logo.svg';
// import { Responsive } from 'common/components';
import * as css from './MobilePopup.scss';

export default class MobilePopup extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		selection: PropTypes.shape({}).isRequired,
		isShowPopup: PropTypes.bool.isRequired,
		allItems: PropTypes.shape({}).isRequired,
		hidePopup: PropTypes.func.isRequired,
		user: PropTypes.shape({}),
	};

	static defaultProps = {
		className: '',
		user: null,
	};

	state = {
		// items: [],
		clicks: 0,
		isTextHideBg: false,
	};

	componentDidMount() {
		document.body.style.overflow = 'hidden';
		document.getElementsByTagName('html')[0].style.overflow = 'hidden';
	}

	componentDidUpdate() {}

	componentWillUnmount() {}

	renderItems = () => {
		const selection = _.get(this.props, 'selection', {});
		// const allItems = _.get(this.props, 'allItems', {});
		// const user = _.get(this.props, 'user', {});
		// const allItemsArr = _.values(allItems);
		// const displayItems = [];
		// if (selection.songs.selectedItems.length !== 0) {
		// 	allItemsArr.map(item => {
		// 		// if (!_.isEmpty(selection)) {
		// 		if (selection.songs.selectedItems.indexOf(item.id) >= 0) {
		// 			displayItems.push({ artistName: item.artistName, songName: item.songName });
		// 		}
		// 		// }

		// 		return null;
		// 	});
		// } else {
		// 	allItemsArr.map(item => {
		// 		// if (!_.isEmpty(selection)) {
		// 		if (user.selection.indexOf(item.id) >= 0) {
		// 			displayItems.push({ artistName: item.artistName, songName: item.songName });
		// 		}
		// 		// }

		// 		return null;
		// 	});
		// }

		return (
			<ul>
				{selection.map(item => {
					return (
						<li key={item.songName}>
							<p>
								<span>{item.title}</span> - <span>{item.subtitle}</span>
							</p>
						</li>
					);
				})}
			</ul>
		);
	};

	closeClickHandler = () => {
		const { hidePopup } = this.props;

		if (this.state.clicks === 0) {
			this.setState({
				clicks: 1,
				isTextHideBg: true,
			});
		} else {
			this.setState(
				{
					clicks: 0,
					isTextHideBg: false,
				},
				() => {
					hidePopup();
					document.body.style = '';
					document.getElementsByTagName('html')[0].style = '';
				}
			);
		}
	};

	render() {
		const { className, isShowPopup, selection } = this.props;
		const { isTextHideBg } = this.state;
		if (_.isEmpty(selection)) return null;

		return (
			<div
				className={classNames(css.mobilePopup, className, isShowPopup && css.show)}
				// style={{ backgroundImage: 'url(/assets/client/imgs/insta-bg.jpg)' }}
			>
				{/* <div
					className={css.genearlBgMobile}
					style={{ backgroundImage: 'url(/assets/client/imgs/insta-bg.jpg)' }}
				></div> */}
				<div className={classNames(css.topText, isTextHideBg && css.hideText)}>
					<div className={css.text}>צלמו מסך ושתפו את הבחירות שלכם!</div>
					<div className={css.closePopup} onClick={this.closeClickHandler}></div>
				</div>
				<div className={css.siteLogo}>
					<img src={siteLogoImg} alt="logo" />
				</div>
				<div className={css.contentList}>
					<div className={css.itemsTitle}>השירים שלי לשנת 2025</div>
					<div className={css.items}>{this.renderItems()}</div>
				</div>
			</div>
		);
	}
}
